import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setZonesAction,
  setZoneAction,
  removeZoneAction,
  setZonesStatusAction,
  setZonesErrorsAction,
  clearZonesErrorsAction
} from './zones.actions'

export const fetchZones = portalId => async dispatch => {
  try {
    dispatch(setZonesStatusAction('loading'))
    dispatch(clearZonesErrorsAction())

    const { data } = await branditRails.get('/zones', { params: { portal_id: portalId } })

    const zonesById = data.reduce((acc, zone) => {
      acc[zone.id] = zone
      return acc
    }, {})

    dispatch(setZonesAction(zonesById))
    dispatch(setZonesStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setZonesErrorsAction({ message: errorMessage }))
    dispatch(setZonesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const createZone = formData => async dispatch => {
  try {
    dispatch(setZonesStatusAction('loading'))
    dispatch(clearZonesErrorsAction())

    const { data } = await branditRails.post('/zones', formData)

    dispatch(setZoneAction(data))
    dispatch(setZonesStatusAction('succeeded'))
    toastr.success('Success', 'Zone created successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setZonesErrorsAction({ message: errorMessage }))
    dispatch(setZonesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const updateZone = (zoneId, formData) => async dispatch => {
  try {
    dispatch(setZonesStatusAction('loading'))
    dispatch(clearZonesErrorsAction())

    const { data } = await branditRails.patch(`/zones/${zoneId}`, formData)

    dispatch(setZoneAction(data))
    dispatch(setZonesStatusAction('succeeded'))
    toastr.success('Success', 'Zone updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setZonesErrorsAction({ message: errorMessage }))
    dispatch(setZonesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const deleteZone = zoneId => async dispatch => {
  try {
    dispatch(setZonesStatusAction('loading'))
    dispatch(clearZonesErrorsAction())

    await branditRails.delete(`/zones/${zoneId}`)

    dispatch(removeZoneAction(zoneId))
    dispatch(setZonesStatusAction('succeeded'))
    toastr.success('Success', 'Zone deleted successfully!')
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setZonesErrorsAction({ message: errorMessage }))
    dispatch(setZonesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
